import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { nistCsfFunctions } from '../../data/nistCsf';
import './NistCompliance.css';

const NistCompliance = () => {
  const [activeTab, setActiveTab] = useState(nistCsfFunctions[0]);

  return (
    <div className="nist-container">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="nist-header"
      >
        <h2 className="section-title center">NIST CSF ALIGNMENT</h2>
        <p className="section-description center">
          PassiveGuard supports the six NIST Cybersecurity Framework 2.0 functions, helping teams connect governance, risk visibility, safeguards, detection, response, and recovery.
        </p>
        <Link to="/docs/nist-csf" className="gh-btn nist-docs-link">
          View CSF mapping
        </Link>
      </motion.div>

      <div className="nist-content-wrapper">
        <div className="nist-tabs">
          {nistCsfFunctions.map((item) => (
            <button
              key={item.id}
              className={`nist-tab ${activeTab.id === item.id ? 'active' : ''}`}
              onClick={() => setActiveTab(item)}
            >
              <span className="nist-tab-indicator"></span>
              {item.label}
            </button>
          ))}
        </div>

        <div className="nist-display-area">
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab.id}
              initial={{ opacity: 0, x: 20, filter: 'blur(10px)' }}
              animate={{ opacity: 1, x: 0, filter: 'blur(0px)' }}
              exit={{ opacity: 0, x: -20, filter: 'blur(10px)' }}
              transition={{ duration: 0.3 }}
              className="nist-active-content"
            >
              <div className="nist-desc-box">
                <h3>{activeTab.label} Function</h3>
                <p>{activeTab.desc}</p>
              </div>

              <div className="nist-features-grid">
                <h4>PassiveGuard Capabilities</h4>
                {activeTab.capabilities.map((feature, idx) => (
                  <motion.div 
                    key={idx}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: idx * 0.1 + 0.2 }}
                    className="nist-feature-item"
                  >
                    <span className="nist-feature-bullet">&gt;</span>
                    {feature}
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default NistCompliance;
